// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);
  padding: 20px;
  position: relative;
  z-index: 1;
}

.auth-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.05);
  padding: 48px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  position: relative;
  z-index: 2;
}

/* Brand lockup (icon + wordmark) */
.brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 20px;
}

.brand-mark {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  background: linear-gradient(135deg, #60a5fa 0%, #2563eb 100%);
  display: grid;
  place-items: center;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.25);
}

.brand-icon {
  width: 28px;
  height: 28px;
  /* Make the black SVG appear white on the blue tile */
  filter: brightness(0) invert(1);
}

.brand-text {
  text-align: left;
}

.brand-title {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #111827;
}

.brand-tagline {
  font-size: 12px;
  color: #6B7280;
  margin-top: 2px;
}

.auth-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 8px;
  letter-spacing: -0.025em;
}

.auth-subtitle {
  font-size: 16px;
  color: #4a5568;
  margin-bottom: 32px;
  line-height: 1.5;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}

.input-group {
  text-align: left;
  position: relative;
  z-index: 3;
}

.input-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  margin-bottom: 8px;
}

.input-group input {
  width: 100%;
  padding: 12px 16px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 15px;
  transition: all 0.2s;
  background: white;
  position: relative;
  z-index: 3;
  cursor: text;
}

.input-group input:hover {
  border-color: #cbd5e0;
}

.input-group input:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.input-group input:disabled {
  background: #f7fafc;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-primary {
  background: #4299e1;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  width: 100%;
}

.btn-primary:hover:not(:disabled) {
  background: #3182ce;
  transform: translateY(-1px);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.btn-primary:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-google {
  background: white;
  color: #2d3748;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.2s;
  width: 100%;
}

.btn-google:hover:not(:disabled) {
  background: #f7fafc;
  border-color: #cbd5e0;
  transform: translateY(-1px);
}

.btn-google:active:not(:disabled) {
  transform: translateY(0);
}

.btn-google:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 32px 0;
  color: #a0aec0;
  font-size: 13px;
  font-weight: 500;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1 1;
  border-bottom: 1px solid #e2e8f0;
}

.divider span {
  padding: 0 16px;
}

.auth-link {
  color: #4299e1;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s;
}

.auth-link:hover {
  color: #3182ce;
  text-decoration: none;
}

/* Ensure button.auth-link looks like a link */
button.auth-link {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
}

.error-message {
  color: #e53e3e;
  font-size: 14px;
  margin-top: 8px;
  background: #fff5f5;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #feb2b2;
}

.success-message {
  color: #38a169;
  font-size: 14px;
  margin-top: 8px;
  background: #f0fff4;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #9ae6b4;
}

.auth-footer {
  margin-top: 32px;
  font-size: 14px;
  color: #4a5568;
  line-height: 1.5;
}

.auth-footer a {
  margin-left: 4px;
}

.privacy-policy-group {
  margin: 1rem 0;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: var(--text-secondary);
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  margin-top: 0.2rem;
  cursor: pointer;
}

.privacy-link {
  color: #4299e1;
  text-decoration: none;
  transition: color 0.2s;
}

.privacy-link:hover {
  color: #3182ce;
  text-decoration: underline;
}

.legal-links {
  margin: 16px 0;
  font-size: 13px;
  color: #6B7280;
  display: flex;
  justify-content: center;
  gap: 12px;
  align-items: center;
}

.legal-link {
  color: #4299e1;
  text-decoration: none;
  transition: color 0.2s;
}

.legal-link:hover {
  color: #3182ce;
  text-decoration: underline;
}

.legal-separator {
  color: #D1D5DB;
}

@media (max-width: 480px) {
  .auth-card {
    padding: 24px 20px;
  }
  
  .auth-title {
    font-size: 24px;
  }
  
  .auth-subtitle {
    font-size: 15px;
    margin-bottom: 20px;
  }
  .brand { margin-bottom: 12px; }
  .brand-mark { width: 48px; height: 48px; }
  .brand-icon { width: 24px; height: 24px; }
  .auth-form { gap: 16px; margin-bottom: 20px; }
  .btn-primary, .btn-google { padding: 12px 18px; }
  .divider { margin: 16px 0; }
  .auth-footer { margin-top: 20px; }
  .legal-links { margin: 12px 0; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Auth.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oFAAoF;EACpF,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA,SAAS,mBAAmB,EAAE;EAC9B,cAAc,WAAW,EAAE,YAAY,EAAE;EACzC,cAAc,WAAW,EAAE,YAAY,EAAE;EACzC,aAAa,SAAS,EAAE,mBAAmB,EAAE;EAC7C,4BAA4B,kBAAkB,EAAE;EAChD,WAAW,cAAc,EAAE;EAC3B,eAAe,gBAAgB,EAAE;EACjC,eAAe,cAAc,EAAE;AACjC","sourcesContent":[".auth-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #f6f9fc 0%, #eef2f7 100%);\n  padding: 20px;\n  position: relative;\n  z-index: 1;\n}\n\n.auth-card {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.05);\n  padding: 48px;\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n  position: relative;\n  z-index: 2;\n}\n\n/* Brand lockup (icon + wordmark) */\n.brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-bottom: 20px;\n}\n\n.brand-mark {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #60a5fa 0%, #2563eb 100%);\n  display: grid;\n  place-items: center;\n  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.25);\n}\n\n.brand-icon {\n  width: 28px;\n  height: 28px;\n  /* Make the black SVG appear white on the blue tile */\n  filter: brightness(0) invert(1);\n}\n\n.brand-text {\n  text-align: left;\n}\n\n.brand-title {\n  font-size: 20px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  color: #111827;\n}\n\n.brand-tagline {\n  font-size: 12px;\n  color: #6B7280;\n  margin-top: 2px;\n}\n\n.auth-title {\n  font-size: 28px;\n  font-weight: 700;\n  color: #1a202c;\n  margin-bottom: 8px;\n  letter-spacing: -0.025em;\n}\n\n.auth-subtitle {\n  font-size: 16px;\n  color: #4a5568;\n  margin-bottom: 32px;\n  line-height: 1.5;\n}\n\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-bottom: 32px;\n}\n\n.input-group {\n  text-align: left;\n  position: relative;\n  z-index: 3;\n}\n\n.input-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.input-group input {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 15px;\n  transition: all 0.2s;\n  background: white;\n  position: relative;\n  z-index: 3;\n  cursor: text;\n}\n\n.input-group input:hover {\n  border-color: #cbd5e0;\n}\n\n.input-group input:focus {\n  outline: none;\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.input-group input:disabled {\n  background: #f7fafc;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.btn-primary {\n  background: #4299e1;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 14px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  width: 100%;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #3182ce;\n  transform: translateY(-1px);\n}\n\n.btn-primary:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-primary:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.btn-google {\n  background: white;\n  color: #2d3748;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 14px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  transition: all 0.2s;\n  width: 100%;\n}\n\n.btn-google:hover:not(:disabled) {\n  background: #f7fafc;\n  border-color: #cbd5e0;\n  transform: translateY(-1px);\n}\n\n.btn-google:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.btn-google:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  margin: 32px 0;\n  color: #a0aec0;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.divider::before,\n.divider::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.divider span {\n  padding: 0 16px;\n}\n\n.auth-link {\n  color: #4299e1;\n  text-decoration: none;\n  font-weight: 600;\n  transition: color 0.2s;\n}\n\n.auth-link:hover {\n  color: #3182ce;\n  text-decoration: none;\n}\n\n/* Ensure button.auth-link looks like a link */\nbutton.auth-link {\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.error-message {\n  color: #e53e3e;\n  font-size: 14px;\n  margin-top: 8px;\n  background: #fff5f5;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #feb2b2;\n}\n\n.success-message {\n  color: #38a169;\n  font-size: 14px;\n  margin-top: 8px;\n  background: #f0fff4;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #9ae6b4;\n}\n\n.auth-footer {\n  margin-top: 32px;\n  font-size: 14px;\n  color: #4a5568;\n  line-height: 1.5;\n}\n\n.auth-footer a {\n  margin-left: 4px;\n}\n\n.privacy-policy-group {\n  margin: 1rem 0;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 0.9rem;\n  color: var(--text-secondary);\n  cursor: pointer;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin-top: 0.2rem;\n  cursor: pointer;\n}\n\n.privacy-link {\n  color: #4299e1;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.privacy-link:hover {\n  color: #3182ce;\n  text-decoration: underline;\n}\n\n.legal-links {\n  margin: 16px 0;\n  font-size: 13px;\n  color: #6B7280;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  align-items: center;\n}\n\n.legal-link {\n  color: #4299e1;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.legal-link:hover {\n  color: #3182ce;\n  text-decoration: underline;\n}\n\n.legal-separator {\n  color: #D1D5DB;\n}\n\n@media (max-width: 480px) {\n  .auth-card {\n    padding: 24px 20px;\n  }\n  \n  .auth-title {\n    font-size: 24px;\n  }\n  \n  .auth-subtitle {\n    font-size: 15px;\n    margin-bottom: 20px;\n  }\n  .brand { margin-bottom: 12px; }\n  .brand-mark { width: 48px; height: 48px; }\n  .brand-icon { width: 24px; height: 24px; }\n  .auth-form { gap: 16px; margin-bottom: 20px; }\n  .btn-primary, .btn-google { padding: 12px 18px; }\n  .divider { margin: 16px 0; }\n  .auth-footer { margin-top: 20px; }\n  .legal-links { margin: 12px 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
